import type { TranslationSchema } from '../pt-BR';
import type { DeepPartialStrings } from '../types';

export const reminders = {
    inactivity: {
        title_one: "It's been {{count}} day since your last review",
        title_other: "It's been {{count}} days since your last review",
        body: 'Open Kontto to check your month, due dates and pending items.',
    },
    advanceCharge: {
        bodyCard: '{{amount}} will be charged tomorrow. Tap to review.',
        bodyDue: '{{amount}} is due tomorrow. Tap to review.',
    },
    due: {
        payments_one: '{{count}} payment',
        payments_other: '{{count}} payments',
        receipts_one: '{{count}} incoming payment',
        receipts_other: '{{count}} incoming payments',
        itemsToPay_one: '{{count}} item to pay',
        itemsToPay_other: '{{count}} items to pay',
        itemsToReceive_one: '{{count}} item to receive',
        itemsToReceive_other: '{{count}} items to receive',
        titleMixed: 'Today: {{payments}} and {{receipts}}',
        titlePay: 'Today: {{items}}',
        titleReceive: 'Today: {{items}}',
        payLabel: 'Pay {{amount}}',
        receiveLabel: 'Receive {{amount}}',
    },
    trial: {
        valueTitle: 'Your report is ready 📊',
        valueBodyWithCount:
            'You logged {{count}} expenses — your {{month}} report is ready, with categories and PDF. Take a look.',
        valueBody:
            'Your {{month}} report is building itself: categories, cash flow and PDF. Take a look at what Pro has ready.',
        endTitle: 'Your free trial is ending',
        endBodyWithCount:
            "As promised, here's your heads-up: {{days}} days of free Kontto Pro left. Your {{count}} expenses from {{month}} are already a report — if it's not for you, cancel in the {{store}} and you'll pay nothing.",
        endBody:
            "{{days}} days of free Kontto Pro left. As promised, here's your heads-up: if it's not for you, cancel in the {{store}} and you'll pay nothing.",
        cancelledTitleWithCount: 'Your report locks tomorrow',
        cancelledBodyWithCount: "You've already logged {{count}} entries with Pro. Tap to keep everything unlocked.",
        cancelledTitle: 'Your Pro ends tomorrow',
        cancelledBody: 'Reports, statement check and unlimited use stop tomorrow. Tap to keep everything unlocked.',
        lifetimeTrialTitle: 'Cancel your trial to avoid a charge',
        lifetimeTrialBody:
            "You already have Lifetime, but the free trial of the recurring plan is still active and the {{store}} will charge on {{date}}. It won't cancel itself: cancel it in {{location}}.",
        lifetimePaidTitle: 'Cancel your subscription to avoid paying again',
        lifetimePaidBody:
            "You already have Lifetime, but your recurring subscription renews on {{date}} and the {{store}} will charge. It won't cancel itself: cancel it in {{location}}.",
    },
    driveBackup: {
        title: 'Your Drive backup stopped',
        body: 'Tap to reconnect your Google account and protect your data again.',
    },
    activation: {
        title: 'Start with your first expense',
        body: "Log one of today's expenses and watch your Kontto come to life — it takes 10 seconds.",
    },
    secondEntry: {
        title: "Don't stop at your first expense",
        body: "Log today's and your money starts getting organized. Takes seconds.",
    },
    backupAlert: {
        autoStoppedTitle: 'Your automatic backup stopped',
        autoStoppedBody:
            'The last one was on {{date}}. Anything you added since then only exists on this device.',
        staleTitle: 'Your last copy is from {{date}}',
        staleBody_one: 'You have {{count}} entry stored only here. If the phone is gone, so is it.',
        staleBody_other: 'You have {{count}} entries stored only here. If the phone is gone, so are they.',
        neverTitle_one: 'Your {{count}} entry only exists here',
        neverTitle_other: 'Your {{count}} entries only exist here',
        neverBody: 'No backup copy so far. You can export one right now, in two taps.',
    },
    channels: {
        activation: 'Getting started',
        inactivity: 'Come-back reminder',
        due: 'Financial reminders',
        driveBackup: 'Drive backup',
        trial: 'Free trial notice',
        advanceCharge: 'Charge alerts',
        backupAlert: 'Backup notice',
    },
} satisfies DeepPartialStrings<TranslationSchema['reminders']>;
